/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyV2ListRequest {
    getFixupPrototypeFunction() { return PolicyV2ListRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyV2ListRequest>): PolicyV2ListRequest {
        let obj = Object.assign(new PolicyV2ListRequest(), model);
        PolicyV2ListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyV2ListRequest>): PolicyV2ListRequest {
        if (!model) return null;
        return PolicyV2ListRequest.newInstance(<PolicyV2ListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyV2ListRequest) {
        if (!obj) return;

        models.PolicyV2ListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyV2ListRequest): boolean {
        Object.setPrototypeOf(obj, PolicyV2ListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.PolicyFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.PolicySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.PolicySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.PolicyFilter;

}
